import { render, staticRenderFns } from "./ChangeBillStatus.vue?vue&type=template&id=3774b1b2&scoped=true"
import script from "./ChangeBillStatus.vue?vue&type=script&lang=js"
export * from "./ChangeBillStatus.vue?vue&type=script&lang=js"
import style0 from "./ChangeBillStatus.vue?vue&type=style&index=0&id=3774b1b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3774b1b2",
  null
  
)

export default component.exports